import { inject, Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { LookupService } from '@doc/api/server-bo';

@Injectable({
  providedIn: 'root'
})
export class BlockLayoutResolver implements Resolve<boolean> {

  private lookUpService= inject(LookupService);
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.lookUpService.getEnumItems('BlockLayoutType').pipe(
      catchError(error => {
        return [];
      })
    )
  }
}
